import React from 'react';

const Screen =(props)=>{
    return <div>
        Coming soon...
    </div>
}

export default Screen;